import { useRouteError } from 'react-router-dom';
import { TextArea } from 'semantic-ui-react';
import { DisplayMessage } from './displayMessage';

const b64EncodeUnicode = (str) => btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)));

export function RouteErrorBoundary() {
  const error = useRouteError();

  if (!error) {
    return null;
  }

  const errorInfo = process.env.NODE_ENV === 'production'
    ? b64EncodeUnicode(JSON.stringify({ message: error.message, stack: error.stack }))
    : JSON.stringify({ message: error.message, stack: error.stack }, null, 2);

  return (
    <DisplayMessage
      helmet=':('
      header={<span className='f1'>:(</span>}
      content={(
        <>
          An internal error in the application has occurred,
          <br />
          <br />
          Click
          {' '}
          <a href='/'>here</a>
          {' '}
          to return to the main page.
          <br />
          <br />
          If you want to help us, send us this message by email to (Altomobile@outlook.com):
          <br />
          <br />
          <TextArea
            className='w-100'
            value={errorInfo}
            rows={10}
            readOnly
          />
        </>
      )}
    />
  );
}
